import { InputLeftAddon as BaseInputLeftAddon } from "@chakra-ui/react";

export default BaseInputLeftAddon;
